'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

type RenderProps = {
  conversationTransactionId: number | undefined
  conversationTransactionIsBundle: boolean | undefined
}

type Props = {
  children: (props: RenderProps) => JSX.Element
}

const RequestReturnConversationWrapper = ({ children }: Props) => {
  const { conversation } = useConversationContext()
  const conversationTransactionId = conversation?.transaction?.id
  const conversationTransactionIsBundle = conversation?.transaction?.isBundle

  return children({ conversationTransactionId, conversationTransactionIsBundle })
}

export default RequestReturnConversationWrapper
